<template>
  <button @click="add" class="btn waves-effect waves-light btn-brico">Ajouter au panier<i class="material-icons right">add_shopping_cart</i></button>
</template>

<script>
export default {
  props: ["product", "quantity", 'length'],
  methods: {
    // Ajoute le produit dans le state
    add: function() {
      if (this.quantity <= 0){
        return false;
      }

      if (this.product.type === 'cutting' && this.length <= 0){
        return false;
      }

      this.$store.commit("add", {
        id: this.product.id,
        name: this.product.name,
        price: this.product.price,
        coefficient: this.product.coefficient,
        stock: this.product.stock,
        type: this.product.type,
        ean: this.product.ean,
        position: this.product.position,
        quantity: this.quantity,
        length: this.length
      });

      this.success();
    },

    // Affiche une pop-up sweet alert avec : message d'ajout au panier avec succès + lien vers panier ou page d'accueil
    success: function() {
      swal(
        "Félicitations",
        "Votre produit a bien été ajouté au panier !",
        "success",
        {
          buttons: {
            skip: {
              text: "Continuer les achats",
              value: false
            },
            goToCard: {
              text: "Se rendre au panier",
              value: true
            }
          }
        }
      ).then(value => {
        switch (value) {
          case true:
            this.$router.push({ name: "basket-view" });
            break;
          case false:
            this.$router.push({ name: "search-view" });
            break;
        }
      });
    }
  }
};
</script>

<style scoped>
button{
  margin-top: 1em;
  margin-bottom: 1.5em;
}
</style>

